import React, {useEffect, useState} from "react";
import {Link, useHistory} from "react-router-dom";
import { getStoriesLists } from "../service";
import { Stories } from "./types";
import CommonTitle from "../components/common-title";
import resume_Icon from '../images/resume_Icon.png'
import usePagination from "../routers/usePagination";
import Pagination from "../components/pagination";
import {CommonLists} from "../components/list/common-lists";
import useImages from "../routers/useImages";

interface StoriesLists  extends Stories{
    coverUrl:string
}

function JobSearch() {
    const [jobs,setJobs] = useState<Array<Stories>>([])
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore } = usePagination();
    const { push } = useHistory()
    const images = useImages()

    useEffect(() => {
        getStoriesLists({
            pageNum
        }).then(res => {
            if(res.code === 1){
                const lists = res.data.list.map((item:any) => {
                    item.type = 0
                    return item
                })

                if((lists as Array<Stories>).length > 0){
                    setJobs(list => list.concat(lists))
                }else{
                    noMore()
                }
            }
        })
    },[pageNum])

    // @ts-ignore
    const _jobs:Array<StoriesLists> = jobs.map(item => {
        item.coverUrl = item.cover
        return item
    })


    return <div className="jobs navPage">
        {
            images && <div className="cover-box1">
                <Link to={'/job/opportunity'}>
                    <div className="bg1">
                        <img src={ images.recruit } alt=""/>
                    </div>
                </Link>
                <Link to={'/job/personnel'}>
                    <div className="bg1">
                        <img src={ images.resume } alt=""/>
                    </div>
                </Link>
            </div>
        }

        <div className="resume-box" onClick={() => push('/user/resume')}>
            <p>完善简历  获取高薪工作机会</p>
            <img className="resume_Icon" src={resume_Icon} alt=""/>
        </div>
        <CommonTitle title={"管家故事"}/>
        <CommonLists lists={ _jobs } path={'/job/story/@id/detail'}/>
        <Pagination ref={pageRef} length={jobs.length} onChange={ (n) => setPage(n) }/>
    </div>
}

export default JobSearch;
